import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
    quotationPermission: [],
    permissionModal: false,
    permissionError: null,
     loading: false, 
};

export const updateQuotationPermission = createAsyncThunk(
    'quotationPermission/updateQuotationPermission',
    async (permissionData, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `https://us-central1-fabdiz-quote.cloudfunctions.net/api/updateQuotationPermission/${permissionData.clientDetails.id}`,
                permissionData
            );
            if (response.status !== 200) {
                throw new Error('Failed to update permission');
            }
            return response.data;
        } catch (error) {
            console.error("Update error:", error);
            return rejectWithValue(error.message);
        }
    }
);

const QuotationPermissionReducer = createSlice({
    name: 'quotationPermission',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateQuotationPermission.fulfilled, (state, action) => {
                const updatedPermission = action.payload;
                state.quotationPermission = state.quotationPermission.map((permission) =>
                    permission.ID === updatedPermission.ID ? updatedPermission : permission
                );
                 state.loading = false;
            })
            .addCase(updateQuotationPermission.rejected, (state, action) => {
                 state.loading = false;
                state.permissionError = action.payload;
            })
            .addCase(updateQuotationPermission.pending, (state) => {
                state.loading = true;
                state.permissionError = null;
            })

    },
});

export default QuotationPermissionReducer.reducer;
